import React, { useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPersonCircleQuestion,
  faEarthAmericas,
} from "@fortawesome/free-solid-svg-icons";
import CustomHook from "./CustomHook";

function Projects() {
  const [listProjects] = useState([
    {
      name: "Project Employee management system",
      des: "As part of this project, I collaborated with the Mini Project Hummatecnology team to develop applications that support effective management of enterprise and office systems.",
      mission: "Front-end Developer, and Back-end Developer",
      language: "HTML5, CSS3, PHP, JavaScript,...",
      images: "Project1.png",
    },
    {
      name: "Project School management system",
      des: "School Management System is a collaborative project by two developers to streamline school administrative tasks. It features student data management, teacher notes, and class schedules, emphasizing ease of use and efficiency while showcasing teamwork and technical expertise.",
      mission: "Front-end Developer, system analysis and Back-end Developer",
      language: "HTML5, CSS3, PHP, JavaScript,...",
      images: "Project2.png",
    },
    {
      name: "Project Classroom management system",
      des: "Classroom Management System is a collaborative project by two developers, featuring class galleries, structures, lesson schedules, and duty rosters to improve classroom organization.",
      mission: "Front-end Developer, system analysis and design",
      language: "HTML5, CSS3, PHP, JavaScript,...",
      images: "Project3.png",
    },
  ]);
  const divs = useRef([]);
  const scrollTab = useRef();
  CustomHook(scrollTab, divs);
  return (
    <section className="projects" ref={scrollTab}>
      <div className="title" ref={(el) => el && divs.current.push(el)}>
        This is my Projects
      </div>
      <div className="des" ref={(el) => el && divs.current.push(el)}>
        {/* 20 */}
        Explore my diverse projects showcasing creativity and technical
        expertise, ranging from interactive web applications to scalable
        back-end systems.
      </div>
      <div className="list">
        {listProjects.map((value, key) => (
          <div
            className="item"
            key={key}
            ref={(el) => el && divs.current.push(el)}
          >
            <div className="images">
              <img src={`/${value.images}`} alt={value.name} />
            </div>
            <div className="content">
              <h3>{value.name}</h3>
              <div className="des">{value.des}</div>
              <div className="mission">
                <div>
                  <FontAwesomeIcon icon={faPersonCircleQuestion} />
                </div>
                <div>
                  <h4>Mission</h4>
                  <div className="des">{value.mission}</div>
                </div>
              </div>
              <div className="mission">
                <div>
                  <FontAwesomeIcon icon={faEarthAmericas} />
                </div>
                <div>
                  <h4>Languages</h4>
                  <div className="des">{value.language}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
export default Projects;
